import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Row, Col, Spinner } from 'reactstrap';
import NavBar from '../NavBar/navBar';
import { analyzeAgro } from '../../actions';
import './agroAnalysis.css';

const AgroAnalysis = () => {
    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    const [blocksPerPlot, setBlocksPerPlot] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [reportHtml, setReportHtml] = useState('');

    const handleFileChange = (event) => {
        const selected = Array.from(event.target.files || []);
        setFiles(selected);
        setError('');
        setReportHtml('');
    };

    const handleAnalyze = async () => {
        if (!files.length) {
            setError('Selecione as imagens da sequência de voo (.jpg/.png) antes de analisar.');
            return;
        }
        setLoading(true);
        setError('');
        setReportHtml('');
        try {
            const response = await dispatch(analyzeAgro(files, blocksPerPlot));
            setReportHtml(response.data);
        } catch (err) {
            const responseData = err && err.data;
            const detail = responseData && (responseData.error || responseData.detalhe);
            setError(detail || 'Não foi possível gerar o relatório. Verifique as imagens e tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-layout">
            <NavBar />
            <div className="dashboard-overview agro-analysis-page">
                <Row className="agro-header">
                    <Col>
                        <h2>Análise Agro</h2>
                        <p className="agro-subtitle">
                            MVP: envie as imagens da sequência de voo (.jpg/.png). O sistema detecta
                            automaticamente a grade de talhões em cada imagem e calcula um índice de
                            vegetação a partir da cor (RGB) — as imagens não têm banda infravermelha
                            nem geolocalização, então isto é uma aproximação, não o NDVI do
                            Cloverfield. Talhões marcados como anomalia estão estatisticamente fora do
                            padrão dos demais na mesma imagem — é um sinalizador para inspeção humana,
                            não um diagnóstico de ferrugem ou de qualquer doença específica.
                        </p>
                    </Col>
                </Row>

                <Row className="agro-controls" data-tut="reactour__agroUpload">
                    <Col md={12} className="agro-upload-row">
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            multiple
                            onChange={handleFileChange}
                            className="agro-file-input"
                        />
                        <label className="agro-blocks-label">
                            Blocos por talhão:
                            <input
                                type="number"
                                min="1"
                                max="20"
                                value={blocksPerPlot}
                                onChange={(e) => setBlocksPerPlot(Math.max(1, parseInt(e.target.value, 10) || 1))}
                                className="agro-blocks-input"
                            />
                        </label>
                        <Button color="primary" onClick={handleAnalyze} disabled={loading || !files.length}>
                            {loading ? <><Spinner size="sm" /> Analisando...</> : 'Analisar'}
                        </Button>
                        {files.length > 0 &&
                            <div className="agro-file-count">{files.length} imagem(ns) selecionada(s)</div>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p className="agro-blocks-hint">
                            Se cada talhão dessa foto já estiver dividido em blocos visíveis (tipo o
                            Cloverfield), informe quantos blocos tem por talhão e o sistema divide cada
                            coluna detectada em partes iguais. Deixe em 1 se os talhões forem fileiras
                            inteiras, sem divisão interna.
                        </p>
                    </Col>
                </Row>

                {error &&
                    <Row><Col><div className="agro-error">{error}</div></Col></Row>
                }

                {loading &&
                    <Row><Col>
                        <div className="agro-loading-note">
                            Detectando talhões e calculando o índice de vegetação para cada imagem —
                            pode levar alguns instantes dependendo do tamanho e da quantidade de fotos.
                        </div>
                    </Col></Row>
                }

                {reportHtml &&
                    <iframe
                        title="Relatório Agro"
                        className="agro-report-frame"
                        srcDoc={reportHtml}
                    />
                }
            </div>
        </div>
    );
};

export default AgroAnalysis;
